export default __webpack_public_path__ + "static/media/nft5.e15b0838.jpg";